/* unplugin-vue-components disabled */import { render } from "./coopPartner.vue?vue&type=template&id=e0543a76&scoped=true"
import script from "./coopPartner.vue?vue&type=script&lang=js"
export * from "./coopPartner.vue?vue&type=script&lang=js"

import "../../assets/css/init/column.less?vue&type=style&index=0&id=e0543a76&lang=less&scoped=true"
import "../../assets/css/about/about.less?vue&type=style&index=1&id=e0543a76&lang=less&scoped=true"

import exportComponent from "/Users/iwowke/Desktop/work/www/iwowke.com/src/m/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e0543a76"]])

export default __exports__